export default __webpack_public_path__ + "static/media/Posterity_Whitepaper_V3.0.0.0427a82c.pdf";